<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/companyLicense']">Datos de la licencia</a></li>
</ul>
<p-card class="p-mt-3">
  <ng-template pTemplate="header">
    <div class="p-card-title">
      Datos de la licencia
    </div>
  </ng-template>
  <div class="p-grid">
    <div class="p-col-12">
      <label for="number_of_users">Fecha de renovación: </label>
      <span>{{license.renew_date?license.renew_date:' Sin fecha de renovación '}}</span>
    </div>
    <div class="p-col-12">
      <label for="number_of_users">Número de usuarios: </label>
      <span>{{license.number_of_users}}</span>
      <!--<input type="text" disabled name="number_of_users" value="{{license.number_of_users}}">-->
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12">
      <h3>Funcionalidades contratadas</h3>
    </div>
    <div class="p-col-12 p-grid p-ml-2">
      <div class="p-col-4" *ngFor="let feature of getFeaturesInGroup('Funcionalidades')">
        {{feature.name}}
      </div>
    </div>
    <div class="p-col-12">
      <h3>Integraciones contratadas</h3>
    </div>
    <div class="p-col-12 p-grid p-ml-2">

      <div class="p-col-4" *ngFor="let feature of getFeaturesInGroup('Integraciones')">
        {{feature.name}}
      </div>
    </div>
  </div>
</p-card>
